const IssueBadge: React.FC<{ children?: React.ReactNode }> = ({ children }) => (
  <span className="inline-flex items-center px-3 py-0.5 rounded-md text-sm leading-5 bg-red-100 text-red-800">
    {children}
  </span>
)

export default IssueBadge
